<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Документы</h3>
            </v-flex>
            <v-flex xs12 sm6>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-toolbar flat color="white">
                    <v-btn
                            large
                            class="mr-12"
                            @click="selectItem()"
                    >
                        Выбрать
                    </v-btn>
                    <v-btn
                            large
                            class="mr-12"
                            @click="close()"
                    >
                        Отмена
                    </v-btn>
                    <v-text-field
                            v-model.trim="search"
                            label="Фильтр"
                            v-on:change="initialize(true)"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-icon
                            large
                            class="mr-2 mt-4"
                            @click="initialize()"
                    >
                        mdi-magnify
                    </v-icon>
                </v-toolbar>
                <v-data-table
                        :items="list.results"
                        :server-items-length="list.last_page"
                        :loading="listLoading.includes('ASDocumentFetchForcedList')"
                        hide-default-footer
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1"
                        v-model="selected"
                        :headers="headers"
                        item-key="id"
                        :show-select="showSelect"
                        :single-select="true"
                >
                    <template v-if="!showSelect" v-slot:header.action="{ header }">
                        <v-btn
                                icon
                                class="mr-2"
                                @click="editItem(defaultCard)"
                        >
                            <v-icon>mdi-pencil-plus</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.doc_date="{ item }">
                        {{item.doc_date|short_date}}
                    </template>
                    <template v-if="!showSelect" v-slot:item.action="{ item }">
                        <v-btn
                                icon
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <template slot="no-data">
                        <v-btn color="primary" @click="initialize">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="list.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'listDocument',
  props: {
    showSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Наименование документа',
          align: 'start',
          sortable: false,
          value: 'doc_name'
        },
        {
          text: 'Дата акта',
          align: 'start',
          sortable: false,
          value: 'doc_date'
        },
        {
          text: 'Номер акта',
          align: 'start',
          sortable: false,
          value: 'doc_num'
        },
        {
          text: 'Наименование организации',
          align: 'start',
          sortable: false,
          value: 'organization_name'
        },
        {
          text: 'Действие',
          align: 'start',
          sortable: false,
          value: 'action'
        }
      ],
      selected: [],
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    list () {
      return this.$store.getters['ASDocument/list']
    },
    defaultCard () {
      return this.$store.getters['gis_gmpForcedAcknowledgement/defaultCard']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize (newSearch = false) {
      this.$store.dispatch('ASDocument/fetchList', {
        pageId: (newSearch) ? 1 : this.pagination.page,
        search: this.search
      }).then(() => {
        if (newSearch) {
          this.pagination.page = 1
        }
      })
    },
    editItem (item) {
      if (item.id === 'new') {
        this.$store.commit('ASDocument/createCard')
      } else {
        this.$store.dispatch('ASDocument/fetchCard', item)
      }
      this.$router.push({ name: 'document_card', params: { id: item.id } })
    },
    getChargeCondition (conditionId) {
      return this.$store.getters['gis_gmpCharge/getChargeCondition'](conditionId)
    },
    getAcknowledgmentStatus (id) {
      return this.$store.getters['gis_gmpCharge/getAcknowledgmentStatus'](id)
    },
    close () {
      // this.$store.commit('gis_gmpCharge/setTab', 'tab-4')
      this.$router.go(-1)
    },
    selectItem () {
      let ides = this.selected.map(function (item) {
        return item
      })
      if (ides.length > 0) {
        this.$store.commit(
          'ASSoftware/setCardDocument',
          ides[0].id
        )
        this.$store.commit('ASDocument/setCard2', ides[0])
        this.close()
      }
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
